export function setCssVariable(name: string, value: string) {
  window.document.documentElement.style.setProperty(
    `--${name}`,
    value,
  )
}
